import { render } from "./RequestRecommendations.vue?vue&type=template&id=25e6e6ca&scoped=true"
import script from "./RequestRecommendations.vue?vue&type=script&lang=js"
export * from "./RequestRecommendations.vue?vue&type=script&lang=js"

import "./RequestRecommendations.vue?vue&type=style&index=0&id=25e6e6ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e6e6ca"]])

export default __exports__